import React, { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
import { Button,  Form, Modal } from 'antd';
import RewardList from './RewardList';
import { Rewards } from './Rewards';
import { useSelector } from 'react-redux';

export const RewardWrapper = ({ setAtiveStep, handleSubmit }: any) => {
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentData, setCurrentData] = useState<any>();
    const rewardList = useSelector((state:any)=> state?.Business?.rewardList)

    useEffect(()=> {
        if(rewardList?.data?.length === 0) {
            setIsModalOpen(true)
        }
    }, [setAtiveStep])


    return (
        <div>
            <RewardList showModal={isModalOpen} handleSubmit={handleSubmit} handleClose={(value:any) => {
                setIsModalOpen(!isModalOpen);
                setCurrentData(value)
                
            }} />
            <Modal footer={false} title={`${currentData?.id ? 'Edit Reward' : 'Add Reward'}`}  open={isModalOpen} closable={false}>
                <Rewards handleClose={() => {setIsModalOpen(false); setCurrentData({})}} setCurrentData={setCurrentData} currentData={currentData}  setAtiveStep={setAtiveStep} />
            </Modal>
        </div>
    );
};
